import React, { Component } from 'react';
import Hero from './components/hero.js';
import Footer from "./components/footer";
import FeaturedCompanies from './components/featuredCompanies';
import CustomerLogos from './components/customerLogos';
import  './utils/analytics';

export default class Work extends Component {
  constructor(props) {
      super(props);
      this.state = {
  			animations: []
  		};
  }
  componentDidMount() {
  }
  render() {
    return (
	  <div>
      <Hero
          title="Case Studies"
          backgroundImage="images/about-back.jpg"
          height="half"
       />
       <div className="max-width-container">
         <FeaturedCompanies />
       </div>
		<h1 className="large-padding centered-text">{'Some of the awesome folks we\'ve helped along the way'}</h1>
        <div className="max-width-container">
  			   <CustomerLogos />
  		  </div>
  		  <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/work.js